import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import GuideLayout from '../components/GuideLayout';
import { GUIDES } from '../content/guides';

export default function GuidesIndex() {
  return (
    <GuideLayout>
      <Seo
        title="Landlord Guides: UK Compliance Explained | LandlordComply"
        description="Plain-English guides for landlords in England: the Renters' Rights Act, rent increases, gas safety certificates and EICRs, checked against GOV.UK and HSE guidance."
        path="/guides"
      />
      <div className="wrap-wide">
        <p className="crumbs"><Link to="/">Home</Link> / Guides</p>
        <h1>Landlord guides</h1>
        <p style={{ maxWidth: 640 }}>
          Plain-English guides for landlords in England. Each one is checked against GOV.UK or HSE guidance, shows
          when it was last reviewed, and links to its sources.
        </p>
        <div className="guide-list">
          {GUIDES.map(g => (
            <Link key={g.slug} to={`/guides/${g.slug}`} className="guide-card">
              <h2>{g.title}</h2>
              <p>{g.summary}</p>
              <span>{g.readMins} min read</span>
            </Link>
          ))}
        </div>
      </div>
    </GuideLayout>
  );
}
